import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import css from './AudienceDistribution.css';
import wrapperCss from './CampaignData.css';

const translatePrefix = 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.REPORTING';
export const COLORS = ['#4BB3FD', '#5D5FEF', '#5ED3B0'];

const AudienceDistribution = ({ testChannels = [], translate, groupsSize }) => {
    const segmentSize = Object.values(groupsSize).reduce((a, b) => a + b, 0);
    const audienceData = testChannels.map((channel, index) => ({
        name: channel.adnetworkDisplayName,
        y: groupsSize[channel.maxRange],
        color: COLORS[index % COLORS.length],
    }));

    const getMiddleTitle = () => {
        return `<div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <span style="font-size: 11px; font-weight: 400; color: #64748B">${translate(
            `${translatePrefix}.METADATA.TOTAL_GROUP_SIZE`
        )}</span>
            <span style="font-size: 22px">
                <b>${segmentSize}</b>
            </span>
        </div>`;
    };

    const chartOptions = {
        chart: {
            type: 'pie',
            height: 600,
            width: 600,
            backgroundColor: 'transparent',
        },
        title: {
            text: '',
        },
        subtitle: {
            text: getMiddleTitle(),
            useHTML: true,
            verticalAlign: 'middle',
            y: 14,
        },
        plotOptions: {
            pie: {
                innerSize: audienceData.length <= 2 ? '67%' : '65%',
                borderWidth: 0,
                size: '35%',
                dataLabels: {
                    enabled: true,
                    distance: 12,
                    style: {
                        fontWeight: 'normal',
                        color: 'black',
                        fontSize: '14px',
                    },
                    connectorWidth: 0,
                },
            },
        },
        tooltip: {
            enabled: true,
        },
        series: [
            {
                name: 'Audience',
                data: audienceData,
                showInLegend: false,
            },
        ],
        credits: {
            enabled: false,
        },
    };

    return (
        <div className={wrapperCss.dashboardPanel}>
            <h2 className={wrapperCss.panelTitle}>
                {translate(`${translatePrefix}.SUBITEMS_TITLES.DISTRIBUTION_AUDIENCES`)}
            </h2>
            <div className={css.chartContainer}>
                <div className={css.pieChartWrapper}>
                    <HighchartsReact options={chartOptions} />
                </div>
            </div>
        </div>
    );
};

AudienceDistribution.propTypes = {
    translate: PropTypes.func,
    testChannels: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            adnetworkName: PropTypes.string.isRequired,
            adnetworkDisplayName: PropTypes.string.isRequired,
            adnetworkLogoPath: PropTypes.string,
            distributionConfigValues: PropTypes.string.isRequired,
            isControlGroup: PropTypes.bool.isRequired,
            adnetworkIntegrationId: PropTypes.number,
            uanId: PropTypes.number,
            adAccountId: PropTypes.string,
            minRange: PropTypes.number.isRequired,
            maxRange: PropTypes.number.isRequired,
        })
    ),
    // eslint-disable-next-line react/forbid-prop-types
    groupsSize: PropTypes.object,
};

export default withLocalize(AudienceDistribution);
